import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Avatar,
  IconButton,
  InputAdornment,
  Container,
} from "@mui/material";
import { LockOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";
import { resetPassword } from "../api/axios";
import { useLocation, useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { email, otp } = location.state || {};

  const validatePassword = (pw) =>
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@#]{8,}$/.test(pw);

  const handleReset = async () => {
    setError("");

    if (!newPassword) {
      setError("Password is required.");
      return;
    }

    if (!validatePassword(newPassword)) {
      setError("Password must be at least 8 characters and include letters and numbers.");
      return;
    }

    try {
      await resetPassword( email, otp, newPassword );
      toast.success("Password reset successful.");
      navigate("/login");
    } catch (err) {
      const msg = err.response?.data?.error || "Failed to reset password.";
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #6E8EF8, #A5DCF8)",
        p: 2,
      }}
    >
      <Container maxWidth="xs">
        <Paper elevation={6} sx={{ p: 4, borderRadius: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Avatar sx={{ bgcolor: "primary.main", mb: 1 }}>
              <LockOutlined />
            </Avatar>
            <Typography variant="h5">Reset Password</Typography>
          </Box>

          {error && (
            <Typography variant="body2" color="error" mb={1}>
              {error}
            </Typography>
          )}

          <TextField
            fullWidth
            label="New Password"
            variant="outlined"
            margin="normal"
            type={showPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            required
          />

          <Button fullWidth variant="contained" sx={{ mt: 2 }} onClick={handleReset}>
            Reset Password
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
